module.exports = __webpack_public_path__ + "img/main-banner-somos-zama-01.111a661c.png";